module.exports = __webpack_public_path__ + "static/media/remove-from-school.906ce905.svg";